const catalog = {
    title: 'Tryb katalogu',
    action: 'ZAPISZ ZMIANY',
};

export default catalog;